import React from 'react';
import { HeadingMedium, LabelMedium, LabelSmall } from 'baseui/typography';
import { Button, KIND } from 'baseui/button';

interface IdModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const IdModal: React.FC<IdModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: '600px',
          maxWidth: '90vw',
          maxHeight: '80vh',
          backgroundColor: '#fff',
          padding: '32px',
          borderRadius: '16px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          overflow: 'auto'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <HeadingMedium style={{ margin: '0' }}>ID Document</HeadingMedium>
          <Button
            kind={KIND.tertiary}
            size="mini"
            onClick={onClose}
            overrides={{
              BaseButton: {
                style: {
                  borderRadius: '50%',
                  width: '32px',
                  height: '32px',
                  padding: '0'
                }
              }
            }}
          >
            ✕
          </Button>
        </div>

        <div
          style={{
            width: '100%',
            height: '300px',
            backgroundColor: '#f8f9fa',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            marginBottom: '24px',
            border: '2px dashed #DEE2E6',
            borderRadius: '12px'
          }}
        >
          <div style={{ marginBottom: '16px' }}>
            <span style={{ fontSize: '48px', opacity: 0.6 }}>📄</span>
          </div>
          <LabelMedium style={{ textAlign: 'center', color: '#666' }}>
            ID Document
          </LabelMedium>
          <LabelSmall style={{ textAlign: 'center', marginTop: '8px', color: '#999' }}>
            Document preview would appear here
          </LabelSmall>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '24px', marginBottom: '24px' }}>
          <div>
            <LabelSmall style={{ color: '#666', marginBottom: '4px' }}>Document Type</LabelSmall>
            <LabelMedium>National ID</LabelMedium>
          </div>
          <div>
            <LabelSmall style={{ color: '#666', marginBottom: '4px' }}>Document Number</LabelSmall>
            <LabelMedium>N/A</LabelMedium>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IdModal;


